import React from "react";
import RecycleBin from "../../Components/OrganizationSettings/RecycleBin";

const WorkspaceRecyclebinPage = ({ organization, user }) => {
    return (
        <RecycleBin
            isAccessedInIframe={true}
            organization={organization}
            user={user}
            showInIframe={true}
        />
    );
};

export default WorkspaceRecyclebinPage; 